
import { Mixins, Component, Watch } from 'vue-property-decorator';
import { Pagination, Button, Card } from 'element-ui';
import { tSearch } from '@/components/Search/index';
import axios from 'axios';
import api from '@/api/video';
import pageMixin from '../../mixins/pageMixin';
import bModal from './components/bModal.vue';
import videoList from './components/videoList.vue';

 @Component({
   components: {
     Pagination,
     tSearch,
     Button,
     bModal,
     Card,
     videoList,
   },
 })
export default class Setting extends Mixins(pageMixin) {
  private videoList: any = []

  private dialogVisible: boolean = false;

  private loading: boolean = true;

  mounted() {
    this.page.pageSize = 42;
    this.getData(true);
  }

  getData(refresh: boolean = false, title: string = '') {
    this.loading = true;
    const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo };
    api.getVideoList(data, title).then((res: any) => {
      if (refresh) {
        this.videoList = [];
        this.page.pageNo = 1;
        this.page.total = 0;
      }
      this.videoList.push(...res.content);
      this.page.total = res.totalElements;
      this.loading = false;
    });
  }

  getScrollData() {
    if (this.videoList.length === (this.page.total || 0)) return;
    this.page.pageNo += 1;
    this.getData();
  }

  getVideoData() {
    this.loading = true;
    this.getData(true);
  }

  uploadVideo() {
    this.dialogVisible = true;
  }

  handleAdvancedSearch(v) {
    this.getData(true, v);
  }
}
